import { StyledSpinner } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledSaveTaskModalText = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledLoadingSpinner = styled(StyledSpinner)`
  margin-right: 0.5rem;
`;
